module.exports = __webpack_public_path__ + "static/img/gift.4c0bf1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download/gift.png
// module id = jITx
// module chunks = 4